import * as React from "react";

export const LevelThree = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <circle cx={22} cy={22} r={22} fill="#169FED" />
    <path
      fill="#fff"
      d="M31.825 11.14v4.023h-7.719v16.812h-4.66V15.163h-7.475V11.14h19.854Z"
    />
    <path
      fill="#fff"
      d="M11.835 33.42v-4.023h7.72V12.586h4.66v16.811h7.474v4.023H11.835Z"
    />
  </svg>
);
